<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Sticker Pack: {{ pack.displayName }}</h4>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.close()"></button>
</div>
<div class="modal-body">
  <div class="stickers">
    @for (sticker of displayedStickers; track $index; let i = $index) {
      <div class="sticker"
        (mouseenter)="onStickerHover(i)">
        @if (sticker.image.mimetype !== 'image/tgs') {
          <div
            class="img-placeholder"
            [class.loaded]="loadedImages.has(i)">
            <img [src]="getThumbnailUrl(sticker.thumbnail.mxc, 120, 120)"
              loading="lazy"
              width="120"
              height="120"
              title="{{[sticker.name, sticker.description].join('\n')}}"
              (load)="onImageLoad(i)"
              alt="{{sticker.name}}"
              />
          </div>
        }
        @if (sticker.image.mimetype === 'image/tgs') {
          <ng-lottie
            [options]="sticker.animationOpts"
            [styles]="{display: 'inline-block'}"
            width="120px"
            height="120px"
            title="{{[sticker.name, sticker.description].join('\n')}}"
            (animationCreated)="onAnimationCreated(i, $event)"
            />
        }
        @if (sticker.image.mimetype === 'image/tgs') {
          <span class="badge-animated">{{'Animated' | translate}}</span>
        }
      </div>
    }
  </div>
  @if (hasMore) {
    <div class="load-more">
      <button type="button" class="btn btn-outline-primary btn-sm" (click)="loadMore()">{{'Load more' | translate}}</button>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="modal.close()"><i class="far fa-times-circle"></i> {{'Close' | translate}}</button>
</div>
